import React from "react";
import { useTranslation } from "react-i18next";
import { Play, Pause, RotateCcw } from "lucide-react";

// Transport controls. Keyboard-accessible (native buttons; Enter/Space activate).
export default function CinematicController({ playing, onPlay, onPause, onRestart }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-1" data-testid="cinematic-controller" role="group"
      aria-label={t("decisionGraph.title")}>
      {playing
        ? <IconBtn onClick={onPause} testid="dg-pause-btn" label={t("decisionGraph.controls.pause")}><Pause className="w-4 h-4" /></IconBtn>
        : <IconBtn onClick={onPlay} testid="dg-play-btn" label={t("decisionGraph.controls.play")}><Play className="w-4 h-4" /></IconBtn>}
      <IconBtn onClick={onRestart} testid="dg-restart-btn" label={t("decisionGraph.controls.restart")}><RotateCcw className="w-4 h-4" /></IconBtn>
    </div>
  );
}

function IconBtn({ children, onClick, testid, label }) {
  return (
    <button onClick={onClick} data-testid={testid} aria-label={label} title={label}
      className="w-8 h-8 rounded-lg flex items-center justify-center bg-[var(--qn-surface-hover)] hover:bg-[var(--qn-card-hover)] text-[var(--qn-foreground)] focus:outline-none focus:ring-2 focus:ring-[var(--qn-primary)]">
      {children}
    </button>
  );
}
